import { Box, FormHelperText, Grid, Typography, useTheme } from '@mui/material';
import React, { useState, useEffect } from 'react';
import OtpInput, { InputProps } from 'react-otp-input';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { maskMobileNumber } from '../../utils/utilityFunctions';
import { useDispatch } from 'react-redux';
import { sendOtp, verifyOtp } from '../../redux-store/actions/onBoarding';
import {
  ApplicationProps,
  CreateApplicationProps,
  SendOtpResponseBody,
  VerifyOtpResponseBody,
} from '../../redux-store/types/api-types';
import { addJointHolder, createApplication } from '../../redux-store/actions/application';
import { OtpTimer } from '../commonComponents';
import { Location } from 'history';
import { Formik } from 'formik';
import { MFSubmitButton } from '../../lib/formik';
import { showError } from '../../redux-store/actions/auth';
import { VERIFY_LOGIN_OTP_SUCCESS } from '../../redux-store/types/auth';

const intialValues: { OTP: string } = {
  OTP: '',
};

export default function EnterOTP({
  location,
}: {
  location: Location<{
    mobile: string;
    unmaskedphone: string;
    umaskedemailId: string;
    otpVerificationToken: string;
    application: ApplicationProps;
    redirectTo: string;
    panVerificationToken: string;
    countryCode: string;
    email: string;
    countryNameAndCode: string;
    accountType: string;
    otpRefNo: string;
    numberOfOTPTries: number;
  }>;
}): JSX.Element {
  const theme = useTheme()
  const { path: currentPathName } = useRouteMatch();

  const { mobile = '', redirectTo = '', application, email = '' } = location.state || {};
  const { id } = application || {};
  const history = useHistory();
  const dispatch = useDispatch();
  const [error, setError] = useState<string>('');
  const [{ otpVerificationToken, otpRefNo, numberOfOTPTries }, setOtpInfo] = useState({
    otpVerificationToken: '', otpRefNo: '', numberOfOTPTries: 0
  });
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const isInvestorDiyOnboarding = currentPathName === '/investor-onboarding/enter-otp'
  const isDiyJointHolder = currentPathName.includes('add-diy-joint-holder')

  const handleSubmit = async (values: { OTP: string }) => {
    const { OTP } = values;
    try {
      if (!OTP || OTP.length !== 6) {
        setError('Enter OTP');
        return;
      }
      setIsLoading(true)
      const response = (await dispatch(
        verifyOtp({ otpVerificationToken, otp: OTP }, (isInvestorDiyOnboarding || isDiyJointHolder))
      )) as unknown as VerifyOtpResponseBody;
      if (response) {
        const { applicantVerificationToken, investorToken, role } = response || {};
        if (isInvestorDiyOnboarding) {
          dispatch({
            type: VERIFY_LOGIN_OTP_SUCCESS, body: {
              token: investorToken,
              role: role
            }
          })
        }
        if (id && redirectTo) {
          const res = (await dispatch(
            addJointHolder({ applicantVerificationToken }, id)
          )) as unknown as CreateApplicationProps;
          if (!res?.isSuccess) {
            dispatch(showError(res?.message as string));
            history.goBack();
            return;
          }
          history.push(redirectTo, { ...(res?.application || {}) });
          setIsLoading(false)
          return;
        }
        const res = (await dispatch(
          createApplication({ applicantVerificationToken })
        )) as unknown as CreateApplicationProps;

        if (!res) return

        if (!res?.isSuccess) {
          setIsLoading(false);
          dispatch(showError(res?.message as string));
          history.goBack();
          return;
        }
        // history.push('/application', { ...(res?.application || {}) });
        history.push(isInvestorDiyOnboarding ? '/investor-onboarding-application/personal-details' : '/application', { ...(res?.application || {}) });
        setIsLoading(false)
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setIsLoading(false)
    }
  };

  useEffect(() => {
    const { otpVerificationToken, otpRefNo, numberOfOTPTries } = location.state || {};
    if (!location.state) {
      history.push('/');
    }
    setOtpInfo({ otpVerificationToken, otpRefNo, numberOfOTPTries });
  }, []);

  const onResend = async () => {
    try {
      const {
        panVerificationToken,
        countryCode,
        countryNameAndCode,
        email,
        unmaskedphone,
        umaskedemailId,
        accountType
      } = location.state;
      const res = (await dispatch(
        sendOtp({
          phoneNumber: unmaskedphone,
          emailId: umaskedemailId,
          panVerificationToken,
          countryCode,
          countryNameAndCode,
          bypassOtp: false,
          // ...((isInvestorDiyOnboarding || isDiyJointHolder) ? {
          //   accountType: isDiyJointHolder ? "" : "EXECUTIONARY"
          // } : { accountType })
          accountType
        }, (isInvestorDiyOnboarding || isDiyJointHolder))
      )) as unknown as SendOtpResponseBody;
      const { otpVerificationToken, otpRefNo, numberOfOTPTries } = res || {};
      setOtpInfo({ otpVerificationToken, otpRefNo, numberOfOTPTries });
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  return (
    <Formik initialValues={intialValues} onSubmit={handleSubmit}>
      {({ values, setValues, handleSubmit }) => (
        <Grid
          container
          component="form"
          noValidate
          onSubmit={handleSubmit}
          px={4}
          rowSpacing={2.5}
        // sx={{
        //   '.MuiTypography-root': {
        //     fontSize: 16,
        //     fontWeight: 500,
        //     textAlign: 'center',
        //   },
        // }}
        >
          <Grid item xs={12}>
            <Typography
              variant='body_500'
              color="text.primary"
              sx={{ wordWrap: "break-word" }}
            >
              An OTP has been sent to your mobile number
              <Typography
                component="span"
                // sx={{ fontWeight: 'bold', color: 'primary.main', textDecoration: 'none' }}
                color="primary.500"
                variant='body_500'
              >
                {' '}
                {mobile}
              </Typography>
              {email && (
                <Typography
                  component="span"
                  color="text.primary"
                  variant='body_500'
                // sx={{ color: 'secondary.main' }}
                >
                  {' '}
                  and email Id{' '}
                  <Typography
                    component="span"
                    color="primary.500"
                    variant='body_500'
                  // sx={{ fontWeight: 'bold', color: 'primary.main', textDecoration: 'none' }}
                  >
                    {' '}
                    {email}
                  </Typography>
                </Typography>
              )}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <OtpInput
              inputType='number'
              renderInput={(inputProps: InputProps) => <input {...inputProps} type='password' style={{ ...inputProps.style }} disabled={isLoading} />}
              value={values.OTP}
              onChange={(OTP: string) => setValues({ OTP })}
              numInputs={6}
              // hasErrored={!!error}
              // isInputNum={true}
              // isInputSecure={true}
              shouldAutoFocus={true}
              containerStyle={{
                display: 'flex',
                // justifyContent: 'center',
                flexWrap: 'wrap',
                // marginBottom: '30px',
              }}
              inputStyle={{
                width: '50px',
                height: "50px",
                margin: '5px',
                backgroundColor: `${theme.palette.primary[500]}1A`,
                // border: 0,
                // borderBottom: '1px solid #979797',
                // fontSize: '30px',
                border: `1px solid ${theme.palette.primary[500]}`,
                borderRadius: "10px",
                outline: 'none',
                borderColor: error ? `${theme.palette.common.red}` : `${theme.palette.text.primary}`,
                color: error ? `${theme.palette.common.red}` : `${theme.palette.text.primary}`,
                ...(theme.typography.body_600)
              }}
            // errorStyle={{ border: `1px solid ${theme.palette.error[500]}`, color: 'error.500' }}
            // focusStyle={{ outline: 'none' }}
            />
            {!!error && (
              <FormHelperText error sx={{ mt: 2, textAlign: 'left', fontSize: '14px' }}>
                {error}
              </FormHelperText>
            )}
          </Grid>
          <Grid item xs={12}>
            <OtpTimer onResend={onResend} numberOfOTPTries={numberOfOTPTries} />
          </Grid>
          <Grid item xs={12} mt={3}>
            <MFSubmitButton label="Submit" loadingEnable={isLoading} />
          </Grid>
        </Grid>
      )
      }
    </Formik >
  );
}

// export function RedirectScreen(): JSX.Element {
//   return (
//     <>
//       <Typography sx={{ fontSize: 24, fontWeight: 'bold', color: 'primary.main' }}>
//         You are now being redirected to Onboard Investor Form
//       </Typography>
//       {/* <MFSubmitButton label="Next" to="/distributor-details" /> */}
//     </>
//   );
// }
